export const Theme = {
  table: [
    'w-full ws:text-xs text-sm text-left text-gray-500',
    'dark:text-gray-400',
    'rtl:text-right'
  ]
};
